import { ApplicationSettings } from '../../models/settings';
import { ComponentListBuilder } from './helpers/component-list-builder';
import { PageTemplate } from '../../models/templates/pageTemplate';
import { EntryCollection } from 'contentful';
import SearchEngineOptimization from '../../models/seo/SearchEngineOptimization';
import { PageType } from '../../constants/page-type';

export default class ComponentBuilderClient {
  public getPageTemplate(
    data: EntryCollection<any>,
    appSettings: ApplicationSettings,
    pageType?: string,
  ): PageTemplate {
    if (!data.items || data.items.length === 0) {
      return null;
    }

    const { fields } = data.items[0];

    const seo = fields.seo?.fields ? new SearchEngineOptimization(fields.seo?.fields) : null;
    const title = seo?.title || fields.title;

    const builder = new ComponentListBuilder();

    this.getComponentList(fields, pageType)?.forEach((component) => {
      builder.addComponent(component, appSettings);
    });

    const brandSidebarNavigation = fields?.brand?.fields?.brandOptions?.fields?.navigation
      ? fields?.brand?.fields?.brandOptions?.fields?.navigation?.fields
      : null;
    const sidebarNavigation = fields.navigation ? fields.navigation?.fields : null;

    return {
      title,
      seo,
      content: builder.build(),
      brandSidebarNavigation,
      sidebarNavigation,
      exclusionReasons: builder.getExclusions(),
    };
  }

  protected getComponentList(fields: any, pageType?: string): any[] {
    if (pageType === PageType.OrderedPage || pageType === PageType.MicrositeOrderedPage) {
      return fields.componentList;
    } else if (pageType === PageType.PagePpArticle) {
      return fields.articleContent;
    } else {
      return Object.values(fields);
    }
  }
}
